<template>
  <div>
  <!-- ユーザ管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>ユーザ管理</span>
        <span class="card-header-actions">
          <!-- 登録画面へ遷移するボタン -->
          <router-link :to="{ name: registerTop }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li style="color: red" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <div class="table-responsive">
        <table class="table table-bordered">
        <thead>
          <tr>
            <th style="width: 16.6%" scope="col" rowspan="2">社員番号</th>
            <th style="width: 16.6%" scope="col" rowspan="2">氏名</th>
            <th style="width: 16.6%" scope="col" rowspan="2">所属部署</th>
            <th style="width: 16.6%" scope="col" rowspan="2">ユーザ種別</th>
            <th scope="colgroup" colspan="4" class="text-center" nowrap>有給(日)</th>
            <th scope="col" rowspan="2" class="position-right" nowrap>代休(日)</th>
            <th style="margin-left: 15px; width: 16.6%" class="title" rowspan="2"></th>
          </tr>
          <tr>
            <th scope="col">
              <a href="#" class="paid-rule-link" @click.prevent="openPaidLeaveRuleModal">区分</a>
            </th>
            <th scope="col" class="position-right">所持日数</th>
            <th scope="col" class="position-right">今期消化</th>
            <th scope="col" class="position-right">付与月</th>
          </tr>
        </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="item.name">
              <td>{{ item.employee_id }}</td>
              <td>
                <router-link :to="{ name: info, params: { id: item.id } }">{{
                  item.name
                }}</router-link>
              </td>
              <td>{{ item.department_name || '' }}</td>
              <td>{{ item.authority_name }}</td>
              <td>{{ workingDaysLabel(item.working_days) }}</td>
              <td class="position-right">{{ item.paid_days.toFixed(1) }}</td>
              <td class="position-right" :style="paidDaysUsedCellStyle(item.paid_days_used)">
                {{ item.paid_days_used.toFixed(1) }}
              </td>
              <td class="position-right">{{ item.paid_days_add }}月</td>
              <td class="position-right">{{ item.comp_days.toFixed(1) }}</td>
              <td>
                <button
                  v-on:click="openModal(item, index)"
                  class="btn btn-danger"
                >
                  無効
                </button>
                <!-- 削除モーダルコンポーネント呼出 -->
                <DeleteModal
                  :draggable="true"
                  :resizable="true"
                  :val="postItem"
                  :loading="loading"
                  v-show="showModal"
                  @delete="deleteUser"
                  @close="closeModal"
                >
                </DeleteModal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
  <!-- 有休付与ルール（区分リンク押下で表示） -->
  <CModal
    :show.sync="showPaidLeaveRuleModal"
    @close="closePaidLeaveRuleModal"
    centered
    size="lg"
    class="paid-rule-modal"
  >

    <CModalHeader :close-button="true">有休付与ルール</CModalHeader>

    <CModalBody class="paid-rule-modal-body">

      <!-- （1）通常の労働者 -->
      <div class="mb-1">
        <label class="mb-0">（1）通常の労働者の付与日数</label>
      </div>
      <div class="table-responsive">
      <table class="table table-bordered mb-3">
        <tr>
          <th class="plr-rowhead">継続勤務年数（年）</th>
          <th
            v-for="(c,i) in paidLeaveNormalColumns"
            :key="'n-h'+i"
            class="plr-colhead text-center"
          >
            {{ c.label }}
          </th>
        </tr>
        <tr>
          <th class="plr-rowhead">付与日数（日）</th>
          <td
            v-for="(c,i) in paidLeaveNormalColumns"
            :key="'n-d'+i"
            class="text-center"
          >
            {{ c.days }}
          </td>
        </tr>
      </table>
      </div>

      <!-- （2）週4日以下かつ週30時間未満 -->
      <div class="mb-1">
        <label class="mb-0">
          （2）週所定労働日数が4日以下かつ週所定労働時間が30時間未満の労働者の付与日数
        </label>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered mb-1">
          <tr>
            <th rowspan="2" class="plr-rowhead text-center">週所定<br />労働日数</th>
            <th rowspan="2" class="plr-rowhead text-center">1年間の<br />所定労働日数※</th>
            <th colspan="7" class="plr-rowhead text-center">継続勤務年数（年）</th>
          </tr>
          <tr>
            <th
              v-for="(c,i) in paidLeaveShortColumns"
              :key="'s-h'+i"
              class="plr-colhead text-center"
            >
              {{ c.label }}
            </th>
          </tr>

          <tr v-for="r in paidLeaveShortRows" :key="'s-r'+r.weeklyDays">
            <th class="plr-rowhead">
              <label class="mb-0">{{ r.weeklyDays }}日</label>
            </th>
            <td class="text-center">{{ r.annualRange }}</td>
            <td
              v-for="(c,i) in paidLeaveShortColumns"
              :key="'s-d'+r.weeklyDays+'-'+i"
              class="text-center"
            >
              {{ r.days[c.key] }}
            </td>
          </tr>
        </table>
        </div>
      <div class="text-muted small">※週以外の期間によって労働日数が定められている場合</div>
    </CModalBody>

    <template #footer>
      <button class="btn btn-secondary" @click="closePaidLeaveRuleModal">閉じる</button>
    </template>
  </CModal>
</div>
</template>

<script>
import ConstList from "./../ConstList";
import DeleteModal from "./DeleteModal";
import axios from "axios";
import VPagination from "vuejs-paginate";
export default {
  name: "List",
  components: {
    DeleteModal,
    VPagination,
  },
  data() {
    return {
      showModal: false,
      postItem: "",
      items: [],
      employee_id: [],
      deleted_flg: [],
      paid_days: "",
      comp_days: "",
      paid_days_used: "",
      paid_days_add: "",
      authority: [],
      errors: [],
      registerTop: "",
      info: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
      showPaidLeaveRuleModal: false,
      paidLeaveNormalColumns: [
        { label: "0.5",    days: 10 },
        { label: "1.5",    days: 11 },
        { label: "2.5",    days: 12 },
        { label: "3.5",    days: 14 },
        { label: "4.5",    days: 16 },
        { label: "5.5",    days: 18 },
        { label: "6.5以上", days: 20 },
      ],
      paidLeaveShortColumns: [
        { label: "0.5",    key: "y05" },
        { label: "1.5",    key: "y15" },
        { label: "2.5",    key: "y25" },
        { label: "3.5",    key: "y35" },
        { label: "4.5",    key: "y45" },
        { label: "5.5",    key: "y55" },
        { label: "6.5以上", key: "y65" },
      ],
      paidLeaveShortRows: [
        {
          weeklyDays: 4,
          annualRange: "169～216日",
          days: { y05: 7, y15: 8, y25: 9, y35: 10, y45: 12, y55: 13, y65: 15 },
        },
        {
          weeklyDays: 3,
          annualRange: "121～168日",
          days: { y05: 5, y15: 6, y25: 6, y35: 8, y45: 9, y55: 10, y65: 11 },
        },
        {
          weeklyDays: 2,
          annualRange: "73～120日",
          days: { y05: 3, y15: 4, y25: 4, y35: 5, y45: 6, y55: 6, y65: 7 },
        },
        {
          weeklyDays: 1,
          annualRange: "48～72日",
          days: { y05: 1, y15: 2, y25: 2, y35: 2, y45: 3, y55: 3, y65: 3 },
        },
      ],
    };
  },

  created() {
    this.registerTop = ConstList.REGISTER_TOP;
    this.info = ConstList.ROUTE_INFO;
  },

  methods: {
    // 一覧表示
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      {
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/users", {
            params: {
              currentPage: this.currentPage,
              pageSize: this.pageSize,
            },
          })
          .then((response) => {
            this.items = response.data;
            if (this.items.length === 0) {
              this.errors.push(ConstList.EMPTY);
            }
          })
          .catch((error) => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          });
      }
    },
    workingDaysLabel: function (v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return '';
      if (n === 5) return '通常';
      if (n === 0) return '付与無し';
      if (n >= 1 && n <= 4) return `週${n}勤務`;
      return '';
    },
    // 有給消化警告色
    paidDaysUsedCellStyle(v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return { color: "black" };
      if (n < 3) return { color: "red" };
      if (n < 5) return { color: "orange" };
      return { color: "black" };
    },

    // モーダルを表示
    openModal: function (item, index) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.postItem = item;
      this.postItem.authority_id = this.authority[index];
      this.showModal = true;
    },

    // ユーザを削除
    deleteUser: function () {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("id", this.postItem.id);
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/delete", params)
        .then(() => {
          alert(ConstList.DELETE_MESSAGE);
          this.showModal = false;
          window.location.reload();
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      console.log("123123123");
      this.callList();
    },

    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/users/count")
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    openPaidLeaveRuleModal: function () {
      this.showPaidLeaveRuleModal = true;
    },
    closePaidLeaveRuleModal: function () {
      this.showPaidLeaveRuleModal = false;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },
};
</script>

<style scoped>
table {
  width: 100%;
}
/* CoreUI/Bootstrap の table 既定を確実に上書き */
.table td.position-right,
.table th.position-right {
  text-align: right !important;
  padding-right: 10px;
}
td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

/* 小画面ではモーダルを横幅いっぱいにして、表は中でスクロールさせる */
@media (max-width: 576px) {
  ::v-deep .paid-rule-modal .modal-dialog {
    max-width: 100vw;
    width: 100vw;
    margin: 0;
  }
  ::v-deep .paid-rule-modal .modal-content {
    border-radius: 0;
  }
}
</style>
